<template>
	<td :width="columnWidth" class="py-4 pe-0 position-relative">
		<div class="position-relative avatar" :class="imageClass">
			<img :src="image" v-placeholder-image class="object-cover position-absolute top-50 start-50 translate-middle" />
		</div>
		<a href="javascript:void(0);" class="stretched-link" @click="select" v-if="hasSelect"></a>
	</td>
</template>

<script>
	import { computed, getCurrentInstance } from 'vue';
	import assetsImgIconsNoImage from '@/assets/img/icons/no-image.jpg';

	export default {
		emits: ['select'],
		props: {
			src: String,
			size: {
				type: String,
				default: 'xl'
			}
		},
		setup(props, { emit }) {
			const hasSelect = typeof getCurrentInstance()?.vnode.props?.onSelect === 'function';
			const select = () => emit('select');

			const image = computed(() => {
				if(props.src) return props.src;
				else return assetsImgIconsNoImage;
			});

			const imageClass = computed(() => {
				switch(props.size) {
					case 'xl':
						return `avatar-xl rounded-4`;
						break;
					case 'lg':
						return `avatar-lg rounded-3`;
						break;
					case 'md':
						return `avatar-md rounded-2`;
						break;
					case 'sm':
						return `avatar-sm rounded-1`;
						break;
				}
			});

			const columnWidth = computed(() => {
				switch(props.size) {
					case 'xl':
						return 85;
						break;
					case 'lg':
						return 75;
						break;
					case 'md':
						return 50;
						break;
					case 'sm':
						return 40;
						break;
				}
			});

			return { hasSelect, select, image, imageClass, columnWidth };
		}
	}
</script>

<style scoped>
	td {
		vertical-align: top;
	}
</style>